module.exports = __webpack_public_path__ + "img/button.41f651d8.png";